// extracted by mini-css-extract-plugin
export var highlightImg = "style-mod--highlight-img--edc87";
export var highlightSubtitle = "style-mod--highlight-subtitle--46633";
export var highlightTitle = "style-mod--highlight-title--11916";
export var highlightTitleSecond = "style-mod--highlight-title-second--f1ce3";
export var highlights = "style-mod--highlights--7f1cc";
export var jumbotron = "style-mod--jumbotron--c0902";
export var jumbotronBackground = "style-mod--jumbotron-background--26d80";
export var jumbotronHighlight = "style-mod--jumbotron-highlight--1618b";
export var rowOnDesktop = "style-mod--row-on-desktop--8a95f";
export var sliderOnMobile = "style-mod--slider-on-mobile--5ac61";